import { Button, Checkbox, Col, Form, Input, InputNumber, Row, Select } from "antd"
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer"
import { DownArrowDraw, HaberForm, RightDrawerContainer } from "../../styledElements"
import { PaperMachineGradeSelect, PaperMachineQualitySelect } from "../../pageStyled"
import { MultiSelect } from "react-multi-select-component"
import { useEffect, useState } from "react"
import { useForm } from "antd/lib/form/Form"
import { getAllGradesForConfig, getGradeQualitiesForConfig } from "../../../Services/settingsServices"
import Iconmoon from "../../../Components/IconsFiles/icon"
import { getUnitData } from "../../../Services/measurementService"
import { updateGenericStockMatchingData } from "../../../Services/stockMatchingServices"

const GenericMatchingCriteriaDrawer = ({visible,onClose,initialData=null}) => {
    const [lengthUnits,setLengthUnits] = useState([]);
    const [form] = useForm();

    useEffect(()=>{
        (async()=>{
            const response = await getUnitData();
            let options = response?.data?.units_management?.length?.data?.map(
                (unit)=>({label:unit,value:unit})
            )
            setLengthUnits(options);
        })();
    },[])


    const handleFormSubmit = async(values) => {
        console.log(initialData,values)
        try{
            if(values?.accept_all_gsm)
            {
                values.gsm_lb=0;
                values.gsm_ub=0;
            }
            if(values?.accept_all_bf)
            {
                values.bf_lb=0;
                values.bf_ub=0;
            }
            if(values?.accept_all_bulk)
            {
                values.bulk_lb=0;
                values.bulk_ub=0;
            }
            if(values?.accept_all_moisture)
            {
                values.moisture_lb=0;
                values.moisture_ub=0;
            }
            const {reel_size_unit,sheet_size_unit,group_name,...rest} = values
            const body = {
                ...rest,
                units:{
                    reel_size_lb: reel_size_unit,
                    reel_size_ub: reel_size_unit,
                    sheet_size_lb: sheet_size_unit,
                    sheet_size_ub: sheet_size_unit,
                }
            }
            await updateGenericStockMatchingData(body);
            onClose();
        }
        catch(e)
        {
            console.log(e);
        }
    }

    return (
        <RightDrawerSidebar title={"Generic Matching Criteria"} visible={visible} onClose={onClose}>
            <RightDrawerContainer>
                <HaberForm>
                    <div className="resetPassForm removePadLeft">
                        <Form
                            name="basic"
                            form={form}
                            onFinish={handleFormSubmit}
                            className="haberLogin haberSignup"
                            style={{marginBlockStart:"0px"}}
                            onValuesChange={(changedValues)=>{
                                console.log(changedValues)
                                if(changedValues.accept_all_gsm)
                                {
                                    form.setFieldsValue({gsm_lb:undefined,gsm_ub:undefined});
                                }
                                if(changedValues.accept_all_bf)
                                {
                                    form.setFieldsValue({bf_lb:undefined,bf_ub:undefined})
                                }
                                if(changedValues.accept_all_bulk)
                                {
                                    form.setFieldsValue({bulk_lb:undefined,bulk_ub:undefined});
                                }
                                if(changedValues.accept_all_moisture)
                                {
                                    form.setFieldsValue({moisture_lb:undefined,moisture_ub:undefined});
                                }
                            }}
                            initialValues={initialData}
                        >
                            <div className="drawerField">
                                <div className="titleWithText">
                                    <h5>GSM tolerance</h5>
                                    <p>Set GSM tolerance applicable</p>
                                </div>
                                <Row gutter={4}>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_gsm"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"gsm_lb"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_gsm"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"LB"} disabled={getFieldValue("accept_all_gsm")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_gsm"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"gsm_ub"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_gsm"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"UB"} disabled={getFieldValue("accept_all_gsm")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                        
                                    </Col>
                                </Row>
                                <div className="titleWithText" style={{marginBlockStart:"-24px"}}>
                                    <Form.Item
                                        name={"accept_all_gsm"}
                                        valuePropName="checked"
                                    >
                                        <Checkbox><p>No tolerance restriction (Accept all values)</p></Checkbox>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="drawerField">
                                <div className="titleWithText">
                                    <h5>Bulk tolerance</h5>
                                    <p>Set Bulk tolerance applicable</p>
                                </div>
                                <Row gutter={4}>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_bulk"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"bulk_lb"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_bulk"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"LB"} disabled={getFieldValue("accept_all_bulk")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_bulk"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"bulk_ub"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_bulk"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"UB"} disabled={getFieldValue("accept_all_bulk")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                        
                                    </Col>
                                </Row>
                                <div className="titleWithText" style={{marginBlockStart:"-24px"}}>
                                    <Form.Item
                                        name={"accept_all_bulk"}
                                        valuePropName="checked"
                                    >
                                        <Checkbox><p>No tolerance restriction (Accept all values)</p></Checkbox>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="drawerField">
                                <div className="titleWithText">
                                    <h5>BF tolerance</h5>
                                    <p>Set BF tolerance applicable</p>
                                </div>
                                <Row gutter={4}>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_bf"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"bf_lb"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_bf"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"LB"} disabled={getFieldValue("accept_all_bf")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_bf"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"bf_ub"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_bf"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"UB"} disabled={getFieldValue("accept_all_bf")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                        
                                    </Col>
                                </Row>
                                <div className="titleWithText" style={{marginBlockStart:"-24px"}}>
                                    <Form.Item
                                        name={"accept_all_bf"}
                                        valuePropName="checked"
                                    >
                                        <Checkbox><p>No tolerance restriction (Accept all values)</p></Checkbox>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="drawerField">
                                <div className="titleWithText">
                                    <h5>Moisture tolerance</h5>
                                    <p>Set Moisture tolerance applicable</p>
                                </div>
                                <Row gutter={4}>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_moisture"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"moisture_lb"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_moisture"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"LB"} disabled={getFieldValue("accept_all_moisture")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_moisture"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"moisture_ub"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_moisture"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"UB"} disabled={getFieldValue("accept_all_moisture")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                        
                                    </Col>
                                </Row>
                                <div className="titleWithText" style={{marginBlockStart:"-24px"}}>
                                    <Form.Item
                                        name={"accept_all_moisture"}
                                        valuePropName="checked"
                                    >
                                        <Checkbox><p>No tolerance restriction (Accept all values)</p></Checkbox>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="drawerField">
                                <div className="titleWithText">
                                    <h5>Reel Size tolerance</h5>
                                    <p>Set Reel Size tolerance applicable</p>
                                </div>
                                <Row gutter={4}>
                                    <Col span={9}>
                                        <Form.Item
                                            name={`reel_size_lb`}
                                            normalize={(value) => {
                                                if (value === '' || value === null || value === undefined) return value;

                                                const num = value.endsWith(".")?value:parseFloat(value);
                                                return isNaN(num) ? value : num;
                                            }}
                                            rules={[
                                                {
                                                    required:true,
                                                    message:"This field is required!"
                                                },
                                                {
                                                    pattern: /^(?:\d+|\d*\.\d+)$/,
                                                    message: "Only non-negative decimal numbers are allowed!"
                                                }
                                            ]}
                                        >
                                            <Input placeholder={"LB"}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={9}>
                                        <Form.Item
                                            name={`reel_size_ub`}
                                            normalize={(value) => {
                                                if (value === '' || value === null || value === undefined) return value;

                                                const num = value.endsWith(".")?value:parseFloat(value);
                                                return isNaN(num) ? value : num;
                                            }}
                                            rules={[
                                                {
                                                    required:true,
                                                    message:"This field is required!"
                                                },
                                                {
                                                    pattern: /^(?:\d+|\d*\.\d+)$/,
                                                    message: "Only non-negative decimal numbers are allowed!"
                                                }
                                            ]}
                                        >
                                            <Input placeholder={"UB"}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item
                                            name={`reel_size_unit`}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "This field is required!"
                                                }
                                            ]}
                                        >
                                            <Select 
                                                placeholder={"Unit"} 
                                                options={lengthUnits}
                                                suffixIcon={<DownArrowDraw/>} 
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                            <div className="drawerField">
                                <div className="titleWithText">
                                    <h5>Sheet Size tolerance</h5>
                                    <p>Set Sheet Size tolerance applicable</p>
                                </div>
                                <Row gutter={4}>
                                    <Col span={9}>
                                        <Form.Item
                                            name={`sheet_size_lb`}
                                            normalize={(value) => {
                                                if (value === '' || value === null || value === undefined) return value;

                                                const num = value.endsWith(".")?value:parseFloat(value);
                                                return isNaN(num) ? value : num;
                                            }}
                                            rules={[
                                                {
                                                    required:true,
                                                    message:"This field is required!"
                                                },
                                                {
                                                    pattern: /^(?:\d+|\d*\.\d+)$/,
                                                    message: "Only non-negative decimal numbers are allowed!"
                                                }
                                            ]}
                                        >
                                            <Input placeholder={"LB"}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={9}>
                                        <Form.Item
                                            name={`sheet_size_ub`}
                                            normalize={(value) => {
                                                if (value === '' || value === null || value === undefined) return value;

                                                const num = value.endsWith(".")?value:parseFloat(value);
                                                return isNaN(num) ? value : num;
                                            }}
                                            rules={[
                                                {
                                                    required:true,
                                                    message:"This field is required!"
                                                },
                                                {
                                                    pattern: /^(?:\d+|\d*\.\d+)$/,
                                                    message: "Only non-negative decimal numbers are allowed!"
                                                }
                                            ]}
                                        >
                                            <Input placeholder={"UB"}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                        <Form.Item
                                            name={`sheet_size_unit`}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "This field is required!"
                                                }
                                            ]}
                                        >
                                            <Select 
                                                placeholder={"Unit"} 
                                                options={lengthUnits}
                                                suffixIcon={<DownArrowDraw/>} 
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                            <div className="fixedBtm buttonFlex">
                                <Button
                                    className="themeBtn"
                                    onClick={()=>{
                                        form.submit();
                                    }}
                                >
                                    <Iconmoon icon={"addcircle"} color="#ffffff" size={16}/>
                                    Save Changes
                                </Button>
                                <Button
                                    className="themeBtn noBg"
                                    onClick={onClose}
                                >
                                    <Iconmoon icon={"delete"} color="#ea655b"  size={16}/>
                                    Cancel
                                </Button>
                            </div>
                        </Form>
                    </div>
                </HaberForm>
            </RightDrawerContainer>
        </RightDrawerSidebar>
    )
}

export default GenericMatchingCriteriaDrawer;